//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import $ from 'jquery';
    export default {
      props: {
        tabClick: {
          type: Function,
          default: undefined,
          require: false
        },
        windResize: {
          type: Function,
          default: undefined,
          require: false
        },
        tabList: Array,
        tabIndex: {
          type: Number,
          default: 0
        },
        contentH: {
          type: Number,
          default: 0
        },
      },
      data(){
        return{
          jumpNum:0,
          tabNum: 1, // tab 切换的页面宽度 ( 通过接口的数据计算 )
          index:0, // 选中了第几个选项卡
          boxNum: 0, // 容器宽度
          windowsW:'',
          marginLeft: 0, // 偏移量
          isMove: true, // 是否在滑动
          startX: 0, startY: 0, moveX: 0, movrY: 0, endX: 0, endY: 0,
          m_sX: 0, m_sY: 0, e_sX: 0, e_xY: 0, sML: 0
        }
      },
      methods: {
        jump(index,e){
          this.index = index;
          this.$emit('tabClick', index)
 /*         let jumpwidth =0;
          if(index+1 < $('.tab li').length/2){
            for(let i = 0;i<index;i++){
              console.log(e.pageX,3333)
              jumpwidth = jumpwidth + parseFloat($('.tab li').eq(i).css('width')) +20;
            }
            if(e.pageX<jumpwidth){
              console.log(1111111)
              $('.tab').animate({'left':'0px'})
            }else {
              $('.tab').animate({'left':'-'+jumpwidth+ 'px'})
            }
          }else {
            $('.tab').css({'left':'auto'})
            $('.tab').animate({'right':'0px'});

          }*/
        },
        start (ev) {
          ev.stopPropagation();
          this.isMove = false;
          this.startX = ev.changedTouches[0].clientX;
          this.startY = ev.changedTouches[0].clientY;
          this.sML = this.marginLeft;
        },
        move (ev) {
          ev.stopPropagation();
          this.moveX = ev.changedTouches[0].clientX;
          this.moveY = ev.changedTouches[0].clientY;
          this.m_sX = this.moveX - this.startX;
          this.m_sY = this.moveY - this.startY;
          var marginLeft = this.sML + this.m_sX;

          marginLeft = marginLeft > 0 ? 0 : marginLeft;
          marginLeft = marginLeft < this.windowsW - this.boxNum * this.windowsW ? this.windowsW - this.boxNum * this.windowsW : marginLeft;
          this.marginLeft = marginLeft;
        },
        end (ev) {
          this.isMove = true;
          if(Math.abs(this.m_sX) > Math.abs(this.m_sY) && Math.abs(this.m_sX) > 60) {
            var multiple = this.m_sX > 0 ? -1 : 1;
            var index = this.index + multiple;
            index = index < 0 ? 0 : index;
            index = index > this.boxNum - 1 ? this.boxNum - 1 : index;
            this.index = index;
            this.$emit('tabClick', index)
          } else {
            this.marginLeft = 0 - this.index * this.windowsW;
          }
        },
        heightWidth(){
          this.windowsW = window.innerWidth;
          this.marginLeft = 0 - this.index * this.windowsW;
          $('.ZDYswipercontent').css({'width':this.windowsW+'px'});
/*
          this.tabwidth = 0;
          for(let i = 0;i<$('.tab li').length;i++){
            this.tabwidth = this.tabwidth + parseFloat($('.tab li').eq(i).css('width')) +20;
          }
          $('.tab').css({'width':this.tabwidth +'px'});*/
          $('.tab li').css({'width':this.windowsW/this.boxNum+'px'});
        }
      },
      mounted(){
        //路由组件的数量
        let _this = this;
        this.boxNum = this.tabList.length;
        this.heightWidth()
        window.onresize=function(){
          _this.$emit('windResize');
           _this.heightWidth();
        };

      },
      watch: {
        tabIndex: function (newValue, oldValue) {
          this.index = this.tabIndex;
        },
        index: function (newValue, oldValue) {
          this.marginLeft = 0 - this.index * this.windowsW;
        },
      /*  contentH: function (newValue, oldValue) {
          console.log(newValue, oldValue,5656565)
          $('.ZDYswipercontent').css({'height':newValue +'px'});
        }*/
      }
    }



// WEBPACK FOOTER //
// ./src/components/tabslideTamplete.vue